<template>
    <custom-dialog type="info" class="deleteAll" title="提示" width="358px" v-if="inventoryTipsDialogShow" :show-close="true"
        :visible="inventoryTipsDialogShow" @close="dialogVisibleClose">
        <div slot="content">
            <div v-if="type == 'diagnos'" class="color1F2 fwb">是否继续完成接诊?</div>
            <div class="content-tips">
                <div class="color1F2" v-if="computedInventory.length > 0">以下商品库存不足：</div>
                <div class="color667 flex-w display-f lh20 mt4 ">
                    <div v-for="item in computedInventory" :key="item.itemId">
                        <span class="mr8">{{ item.itemName}}</span>
                    </div>
                </div>
                <div class="color1F2" v-if="computedOnsale.length > 0">本店暂无以下商品：</div>
                <div class="color667 display-f flex-w lh20 mt4">
                    <div v-for="item in computedOnsale" :key="item.itemId">
                        <span class="mr8">{{ item.itemName }}</span>
                    </div>
                </div>
                <div class="color1F2" v-if="computedPhysiosDisabled.length > 0">本店禁用的理疗项目：</div>
                <div class="color667 display-f flex-w lh20 mt4">
                    <div v-for="item in computedPhysiosDisabled" :key="item.itemId">
                        <span class="mr8">{{ item.itemName }}</span>
                    </div>
                </div>
            </div>
            <div class="btn">
                <custom-button v-if="type == 'diagnos'" type="info" @click="savePrescription">完成接诊</custom-button>
                <custom-button v-if="type == 'diagnos'" type="primary" @click="dialogVisibleClose">返回修改</custom-button>
                <custom-button v-if="type == 'charge'"  type="primary" @click="dialogVisibleClose">取消</custom-button>
            </div>
        </div>
        <div slot="footer"></div>
    </custom-dialog>
</template>
  
<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
export default {
    // 定义引入的组件
    components: { CustomDialog },
    props: {
        inventoryTipsDialogShow: {
            type: Boolean,
            default: false
        },
        drugList: {
            type: Array,
            default: []
        },
        type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
        }
    },
    computed:{
        //计算库存不足的药品
        computedInventory(){
           return this.drugList.filter(item=>{return item.inventory < item.itemNum && item.onSale == '1' && item.goodsType !='8' })
        },
        //计算停售药品
        computedOnsale(){
            return this.drugList.filter(item => { return item.onSale == '0' })
        },
        // 计算禁用的理疗项目
        computedPhysiosDisabled () {
          return this.drugList.filter(item => { return item.goodsType == '8' && item.enableStatus === 2 })
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    created() { },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        dialogVisibleClose() {
            this.$emit('closeInventoryTipsDialog')
        },
        savePrescription() {
            this.$emit('savePrescription')
        }
    },
}
</script>
<style lang="less" scoped>
.content-tips {
    margin-top: 8px;
    background: #F9F9FA;
    padding: 8px;
}

.btn {
    margin-top: 24px;
    text-align: right;
}
</style>